"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_scss_1 = __importDefault(require("./styles.scss"));
var Icon_1 = __importDefault(require("../Icon"));
var classnames_1 = __importDefault(require("classnames"));
var Accordion = function (_a) {
    var title = _a.title, className = _a.className, children = _a.children, active = _a.active, onToggle = _a.onToggle, props = __rest(_a, ["title", "className", "children", "active", "onToggle"]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(className, styles_scss_1["default"].accordion) }, props, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: styles_scss_1["default"].accordionHeader, onClick: function () { return onToggle(); } }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: styles_scss_1["default"].accordionTitleBox }, { children: [(0, jsx_runtime_1.jsx)(Icon_1["default"], { name: "bullet-shadow", className: styles_scss_1["default"].accordionBulletIcon }), (0, jsx_runtime_1.jsx)("h3", __assign({ className: styles_scss_1["default"].accordionTitle }, { children: title }))] })), (0, jsx_runtime_1.jsx)(Icon_1["default"], { name: "chevron", color: "primary", style: { transform: "rotate(".concat(active ? 180 : 0, "deg)") }, className: styles_scss_1["default"].accordionChevronIcon })] })), active &&
                (0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(styles_scss_1["default"].content, " ").concat(active ? "active" : "") }, { children: children }))] })));
};
exports["default"] = Accordion;
